export const IS_CHECKLIST_SYNC_RECOVERY_CANARY =
  process.env.EXPO_PUBLIC_CHECKLIST_SYNC_RECOVERY_CANARY === 'true';

export const CHECKLIST_SYNC_RECOVERY_FEATURE = 'checklist_sync_recovery_v1';
export const RECOVERY_ESCROW_FEATURE = 'recovery_escrow';

// Chave Ed25519 publica raw (32 bytes em base64). A chave privada permanece
// exclusivamente no ambiente confiavel do operador.
export const RECOVERY_RECEIPT_VERIFY_KEY =
  process.env.EXPO_PUBLIC_RECOVERY_RECEIPT_VERIFY_KEY?.trim() ||
  'CjcKdGHsUS1e5flIOb3Pr4AQ9Vm1yHuEhi65U0uSJ4U=';
